import React from 'react'
import Layout from '../Layout/Layout'
import abt_hero from '../images/abt_hero.PNG'

const About = () => {
  return (
    <Layout>
         <div className='uk-container'>
            <div className=' uk-margin-xlarge-top '>

           
            <h1 className='light uk-margin-large-top'>Architects of Ecosystemic Change</h1>


            <div className='uk-grid uk-margin-large-top'>
                <div className='uk-width-1-2@s'>
                         
            <h3 className='uk-text-bold light'>Who We Are</h3>
            <p className='light'>
                Moolu Venture Lab is a Pan-African innovation support organization
                 committed to strengthening the Africa’s innovation, research, and
                  entrepreneurship ecosystems. We are uniquely positioned at the
                   intersection of technology, development, and policy, ensuring
                    that innovation becomes a reliable driver of inclusive growth
                     and sustainable development.
 
            </p>

            <p className='light'>
                Our core belief is that innovation must be intentional, inclusive,
                 and grounded in local realities to truly translate African talent
                  into global competitive advantage.

            </p>
                </div>

                 <div className='uk-width-1-2@s'>
                   <img src= {abt_hero} />
                </div>
            </div>





            </div>


              <div className='uk-grid uk-margin-large-top'>

                <div className='uk-width-1-2@s'>
                    <h3 className='uk-text-bold light'>The Foundational Mandate</h3>
                   <p className='light'>Our mandate is clear and transformative: to
                     accelerate Africa’s innovation potential by empowering ventures,
                      strengthening institutions, and shaping the policies and systems 
                      that enable research and entrepreneurship to flourish.</p>

                      <p className='light'>
                         Our ecosystem is the engine that drives deal flow and founder 
                         success. We provide structured programs designed to de-risk 
                         investments, refine business models, and ready ventures for
                          institutional scale.
                      </p>
                </div>

                  <div className='uk-width-1-2@s'>
                    
                    <h3 className='uk-text-bold light'>Pan-African Innovation Footprint </h3>
                   <p className='light'>We actively bridge Africa and Europe, strengthening entrepreneurial ecosystems
                     across African states and elevating African talent in global deeptech and AI conversations.</p>

                      <p className='light'> Our engagements spanned Nigeria, Liberia, Ghana,
                         Morocco, Rwanda, Portugal (Soft-Landing Program), and Belgium 
                         (AU–EU Innovation Fair). This global presence is designed to
                          create pathways for market access, investment, and cross-continental
                           knowledge transfer for African innovators.</p>
                </div>

             </div>
         </div>
    </Layout>
  )
}

export default About